<template>
  <div>
    <div class="text">
      <p>
        {{
          dictionary[DictionaryField.DCC_PLANRESULTS_REDUCINGYOURCONSUMPTION]
        }}
      </p>
    </div>
    <div class="unit">
      <h2>{{ units }}</h2>
      <h3>{{ dictionary[DictionaryField.TOOLS_GENERAL_UNITS] }}</h3>
    </div>
  </div>
</template>

<script>
import { createComponent } from "@vue/composition-api";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

export default createComponent({
  props: {
    units: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const dictionary = useDictionary();
    return {
      ...dictionary,
    };
  },
});
</script>
